import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ElementRef } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { BaseComponent } from '../../common/page/base.component';
import { LocaleService } from '../../common/locale/locale.service';
import { TranslationMapperService } from '../../common/translation-mapper.service';

@Component({
    selector: 'u-dotcom-ccpa',
    templateUrl: './ccpa.component.html',
    styleUrls: ['./ccpa.component.scss'],
    standalone: false,
})
export class CcpaComponent extends BaseComponent {
    constructor(
        http: HttpClient,
        localeService: LocaleService,
        titleService: Title,
        metaService: Meta,
        translationMapperService: TranslationMapperService,
        el: ElementRef,
    ) {
        super(http, localeService, titleService, metaService, translationMapperService, el);
    }
}
